import { Form, Input } from 'antd';
import React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import API from '../../../../api';
import { useAppSelector } from '../../../../hooks/store';
import { getIsMobile, getUniversity } from '../../../../redux/selectors';
// const speakerEmailValidator = useDebouncedCallback(
//     async (_, value) => {
//         if (/^[\w%+.-]+@[\d.a-z-]+\.[a-z]{2,16}$/i.test(value)) {
//             const token = window.localStorage.getItem('Account')
//             const data = {
//                 email: value,
//             }
//             if (account.account_info && account.account_info.isGroupAdmin) {
//                 data.universityId = account.currentGroupUniversityId
//             }
//             await fetch(`${defaults.api_host}/dashboard/liveStreams/checkSpeaker?${new URLSearchParams(data)}`, {
//                 method: 'GET',
//                 headers: {
//                     Accept: 'application/json',
//                     'Content-Type': 'text/plain',
//                     Authorization: 'Bearer ' + JSON.parse(token),
//                 },
//             }).then((response) => {
//                 const json = response.json()
//                 if (!response.ok) {
//                     return json.then((text) => Promise.reject(new Error(text.error.message)))
//                 }
//             })
//         }
//     },
//     [account]
// )
export var SingUpFormItems = function () {
    var isMobile = useAppSelector(getIsMobile);
    var university = useAppSelector(getUniversity);
    var debounced = useDebouncedCallback(function (_, value) {
        console.log("value", value);
        if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,16}$/i.test(value)) {
            API.communityAccount.checkProspectEmail({ email: value, universityId: university.id }).then(function (response) {
                console.log("resonse", response);
                // return Promise.resolve();
            })
                .catch(function (error) {
                console.log(error);
                // return Promise.reject(new Error('Invalid email address'));
            });
            // return Promise.reject(new Error('Invalid email address'));
        }
    }, 300);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'md:grid md:grid-cols-[1fr_1fr] md:gap-4 [&>.ant-form-item]:mb-4' },
            React.createElement(Form.Item, { name: "firstName", label: isMobile ? null : 'First Name', rules: [
                    {
                        required: true,
                        message: 'Please enter your first name',
                    },
                ] },
                React.createElement(Input, { placeholder: "First Name", type: "text" })),
            React.createElement(Form.Item, { name: "lastName", label: isMobile ? null : 'Last Name', rules: [
                    {
                        required: true,
                        message: 'Please enter your last name',
                    },
                ] },
                React.createElement(Input, { placeholder: "Last Name", type: "text" }))),
        React.createElement(Form.Item, { name: "email", label: isMobile ? null : 'Email', rules: [
                {
                    required: true,
                    message: 'Please enter your email address',
                },
                {
                    validator: debounced,
                },
                // ({ getFieldValue }) => ({
                //     validator() {
                //         const emailValue = getFieldValue('email');
                //         API.communityAccount.checkProspectEmail({email: emailValue, universityId: university.id}).then((resonse) => {
                //             if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,16}$/i.test(emailValue)) {
                //                 return Promise.reject(new Error('Invalid email address'));
                //             }
                //             return Promise.resolve();
                //         })
                //         .catch((error) => {
                //             return Promise.reject(new Error('Invalid email address'));
                //         })
                //     }
                // }),
            ] },
            React.createElement(Input, { placeholder: "Email", type: "email" })),
        React.createElement(Form.Item, { name: "password", label: isMobile ? null : 'Password', rules: [
                {
                    required: true,
                    message: 'Please enter your new password',
                },
            ] },
            React.createElement(Input.Password, { type: "password", placeholder: "Password" }))));
};
